import styled from "styled-components";
import { StandardTableSortablePropertyHeader } from "../../../components/tables/StandardTable";

const FixedWidthHeader = styled(StandardTableSortablePropertyHeader)`
    width: ${({ width }) => width}%;
`;

const StandardParagraphTableHeader = ({ currentSort, sortTable }) => {
    const Header = ({ property, children }) => <FixedWidthHeader sort={currentSort} sortTable={sortTable} property={property}>{children}</FixedWidthHeader>

    return <thead>
        <tr>
            <Header width={25} property={'name'}>Name</Header>
            <Header width={20} property={'createdDate'}>Created</Header>
            <Header width={20} property={'openedDate'}>Opened</Header>
            <Header width={20} property={'publishedDate'}>Published</Header>
        </tr>
    </thead>
}

export default StandardParagraphTableHeader;